"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dragoni": {
    "825c3322": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "skipSearch": false
    }],
    "aschettini": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "39010666": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "skipSearch": false
    }],
    "chiaio": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "134c693a": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "skipSearch": false
    }],
    "pantano": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "83cd8364": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "skipSearch": false
    }],
    "san-marco": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8b8f4cb7": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "skipSearch": false
    }],
    "trivolischi": [{
      "hkey": "224dd55a",
      "slug": "dragoni",
      "name": "Dragoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;